import {configureStore} from '@reduxjs/toolkit';
import slices from './slices';
import api from './api';

const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        ...slices
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(
        api.middleware
    ),
    devTools: process.env.NODE_ENV !== 'production'
});

type AppState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export type {AppState, AppDispatch};
export default store;
